import { ETokenUsageTrendGranularity } from "../types/token-usage";

// NOTE: NSAI-8010 — page sizes the ranking table offers, matching the server's
// 1..100 limitPerPage bound.
export const USER_ANALYTICS_ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100] as const;
export const DEFAULT_USER_ANALYTICS_ROWS_PER_PAGE = 20;
export const FIRST_USER_ANALYTICS_PAGE = 1;

// NOTE: labelKey resolves against the "settings" namespace.
export const USER_ANALYTICS_GRANULARITY_OPTIONS = [
  {
    value: ETokenUsageTrendGranularity.DAY,
    labelKey: "tokenCostUsage.userAnalytics.granularity.day",
  },
  {
    value: ETokenUsageTrendGranularity.WEEK,
    labelKey: "tokenCostUsage.userAnalytics.granularity.week",
  },
  {
    value: ETokenUsageTrendGranularity.MONTH,
    labelKey: "tokenCostUsage.userAnalytics.granularity.month",
  },
] as const;

export const DEFAULT_USER_ANALYTICS_GRANULARITY =
  ETokenUsageTrendGranularity.DAY;

export const USER_ANALYTICS_MULTIPLIER_INPUT_STEP = 0.5;
// NOTE: The server's DTO rejects a multiplier with more decimal places.
export const USER_ANALYTICS_MULTIPLIER_MAX_DECIMALS = 2;
export const USER_ANALYTICS_DECIMAL_COMMA = ",";
export const USER_ANALYTICS_DECIMAL_POINT = ".";
export const USER_ANALYTICS_SPIKE_MULTIPLE_DECIMALS = 1;

// NOTE: A spike day reads like the other dates in the app: `Oct 27, 2026` in
// English (DATE_FORMAT), day-first digits in Russian (DATE_FORMAT_RU) and in
// Arabic (the chat timestamp's date, NSAI-5022).
export const USER_ANALYTICS_DAY_FORMAT_OPTIONS = {
  month: "short",
  day: "numeric",
  year: "numeric",
} as const satisfies Intl.DateTimeFormatOptions;
export const USER_ANALYTICS_NUMERIC_DAY_FORMAT_OPTIONS = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
} as const satisfies Intl.DateTimeFormatOptions;
